import { useSelector } from '@ecommerce/nest-ssr/common';

export const useGemiusKey = (): string => useSelector((state: { gemiusKey: string; }) => state.gemiusKey || '');
